import { SENDQ } from "./actionTypes";
export const sendq=()=>{
    return {
        type: SENDQ
    }
}